import UniversalCookies from 'universal-cookie';
class UniversalCookiesWithContext extends UniversalCookies {
    getPageContext() {
        return {
            url: new URL(window.location.href),
            headers: new Headers(),
        };
    }
}
export default function create() {
    return new UniversalCookiesWithContext();
}
